import type { FC, PropsWithChildren } from 'react';

import { LocalizedAlgoliaProp } from '../LocalizedAlgoliaProp';
import { S } from '~/components/shared/recommendations/tile/styles';
import { useTileContext } from '~/components/shared/recommendations/tile/TileContext';
import { TilePriceStrikethrough } from '~/components/shared/recommendations/tile/TilePriceStrikethrough';
import { TileTitleWithPrice } from '~/components/shared/recommendations/tile/TileTitleWithPrice';
import { useStaticContext } from '~/utilities/context/static/StaticContext';
import { LowestPriceDisplay } from '~/utilities/graphql/codegen';

interface ProductDataInfoProps {
  renderLowestPrice?: boolean | null;
}

export const ProductDataInfo: FC<PropsWithChildren<ProductDataInfoProps>> = ({
  renderLowestPrice,
  children,
}) => {
  const {
    quickViewContent,
    configuration: { lowestPriceDisplay },
  } = useStaticContext();
  const { hideElements } = useTileContext();

  const basePriceColorFallback = quickViewContent?.productPrice?.content?.basePriceColor;

  return (
    <>
      {lowestPriceDisplay === LowestPriceDisplay.Never ? (
        <>
          {hideElements?.name !== true && (
            <S.OneLineText
              variant="subtitle"
              component="p"
              alignment="left"
              testId="product-tile-title"
              data-cs-capture=""
            >
              <LocalizedAlgoliaProp prop="name" />
            </S.OneLineText>
          )}

          {hideElements?.price !== true && (
            <TilePriceStrikethrough discountedColor={basePriceColorFallback} />
          )}
        </>
      ) : (
        <TileTitleWithPrice
          renderLowestPrice={renderLowestPrice}
          discountedColor={basePriceColorFallback}
        />
      )}

      {children}
    </>
  );
};
